import React from "react";
import formatNumber, { convertNumberToWordsInFCFA, formatDateWithTime, getOrderLineWarehouseCode, lineTaxGroupLabel } from "../utils/functions";
import { APP_NAME } from "../utils";
import { QRCodeCanvas } from "qrcode.react";

function getInvoiceLineItems(invoiceData) {
  if (invoiceData?.products?.length > 0) {
    return invoiceData.products;
  }

  const cmds = invoiceData?.oauthAccessCmds ?? invoiceData?.oauth_access_cmds ?? [];
  if (cmds.length > 0) {
    return cmds.map((line) => ({
      name: line.name,
      quantite: line.quantite,
      unite: line.unite,
      p2: line.p2 ?? line.prix_unitaire,
      variant: line.variant ?? null,
      product: line.product ?? null,
      magasin_label: line.magasin_label,
      magasin_code: line.magasin_code,
    }));
  }

  return [];
}

function isRevendeurOauthOrder(invoiceData) {
  if (!invoiceData) return false;

  return Boolean(
    invoiceData.oauthAccessCmds?.length ||
      invoiceData.oauth_access_cmds?.length ||
      (invoiceData.designation && String(invoiceData.designation).startsWith('ASB-'))
  );
}

function invoiceNetAmount(invoiceData) {
  if (isRevendeurOauthOrder(invoiceData)) {
    const paid = parseFloat(invoiceData.montant_payer);
    if (Number.isFinite(paid)) return paid;
  }

  return parseFloat(invoiceData?.montant_net) || 0;
}

export default function FactureComponent({ invoiceData, isCopy = true }) {
  const lineItems = getInvoiceLineItems(invoiceData);
  const netAmount = invoiceNetAmount(invoiceData);
  const isRevendeur = isRevendeurOauthOrder(invoiceData);
  const revendeurLineTotal = lineItems.reduce((sum, item) => {
    const unitPrice = Number(item.p2 ?? item.prix_unitaire ?? 0);
    const qty = Number(item.quantite ?? 0);
    return sum + unitPrice * qty;
  }, 0);

  return (
    <div className={`${isCopy ? 'invoice-copy second-copy' : 'invoice-copy'} relative`}>
      {/* <img src="/assets/img/logo.png" className="absolute rotate-45 z-0" alt={APP_NAME} /> */}
      <div className="flex flex-row justify-between items-start mt-10">
        <div className="">
          <img src="/assets/img/logo_v2.png" height={100} width={100} alt={APP_NAME} />

          {/* <p className="mt-3 font-medium text-sm tracking-widest">
            ASEBat
          </p> */}
          <p className="font-medium text-sm mt-3">C/1775 C, QUARTIER GBEDJEKOME - OUEDO</p>
          {/* <p className="font-medium text-sm">BP 952 ABOMEY - CALAVI, BENIN</p> */}
          <p className="font-medium text-sm">IFU 3202434985932</p>
          {/* <p className="font-medium text-sm">NIM: TS01013080</p> */}
          <p className="font-medium text-sm">info@asebat.com</p>
          <p className="font-medium text-sm">+229 01 61 89 89 00</p>
        </div>

        {invoiceData.statut_commande !== "annulé" &&invoiceData.emecef_data && JSON.parse(invoiceData.emecef_data).codeMECeFDGI && (() => {
          try {
            const parsedData = JSON.parse(invoiceData.emecef_data);
            const decodedData = typeof parsedData === 'string' ? JSON.parse(parsedData) : parsedData;

            if (!decodedData.errors) {
              return (
                <div className="">
                  <p className="mb-0 font-semibold text-[10px]">
                    ELÉMENTS DE SÉCURITÉ DE LA FACTURE NORMALISÉE ­­­
                  </p>
                  <table className="border-collapse w-full text-sm whitespace-pre table-auto">
                    <tbody className="">
                      <tr>
                        <td className="p-1 border font-medium text-sm" rowSpan={4}>
                          <div className="flex flex-row justify-center items-center p-1">
                            <QRCodeCanvas
                              value={decodedData.qrCode}
                              size={80} // Taille du QR code en pixels
                              bgColor={"#ffffff"} // Couleur de fond
                              fgColor={"#000000"} // Couleur du QR code
                              level={"L"} // Niveau de correction d'erreur (L, M, Q, H)
                            />
                          </div>
                        </td>
                        <td className="p-1 border font-medium text-[10px]">Code MECeF/DGI:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.codeMECeFDGI}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF NIM:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.nim}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF Compteurs:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.counters}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF Heure:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.dateTime}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            } else {
              // Afficher uniquement si des erreurs existent
              return null;
            }
          } catch (error) {
            console.error("Erreur lors de l'analyse JSON:", error);
            return null;
          }
        })()}

        {invoiceData.statut_commande === "annulé" && invoiceData.emecef_data_cancel && JSON.parse(invoiceData.emecef_data_cancel).data && (() => {
          try {
            const parsedData = JSON.parse(invoiceData.emecef_data_cancel);
            const decodedData = typeof parsedData === 'string' ? JSON.parse(parsedData) : parsedData;

            if (!decodedData.errors) {
              return (
                <div className="">
                  <p className="mb-0 font-semibold text-[10px]">
                    ELÉMENTS DE SÉCURITÉ DE LA FACTURE NORMALISÉE ­­­
                  </p>
                  <table className="border-collapse w-full text-sm whitespace-pre table-auto">
                    <tbody className="">
                      <tr>
                        <td className="p-1 border font-medium text-sm" rowSpan={4}>
                          <div className="flex flex-row justify-center items-center p-1">
                            <QRCodeCanvas
                              value={decodedData.data.qrCode}
                              size={80} // Taille du QR code en pixels
                              bgColor={"#ffffff"} // Couleur de fond
                              fgColor={"#000000"} // Couleur du QR code
                              level={"L"} // Niveau de correction d'erreur (L, M, Q, H)
                            />
                          </div>
                        </td>
                        <td className="p-1 border font-medium text-[10px]">Code MECeF/DGI:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.data.codeMECeFDGI}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF NIM:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.data.nim}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF Compteurs:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.data.counters}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF Heure:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.data.dateTime}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            } else {
              // Afficher uniquement si des erreurs existent
              return null;
            }
          } catch (error) {
            console.error("Erreur lors de l'analyse JSON:", error);
            return null;
          }
        })()}
      </div>

      <div className="flex flex-row justify-between items-start mt-2">
        <div>
          <p className="font-medium text-sm">
            <span className="font-semibold">Code et Nom Agent</span> : {invoiceData?.user ? `${String(invoiceData.user.id).padStart(3, '0')} - ${invoiceData.user.name}` : "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-semibold">Magasin</span> : {invoiceData.store?.name || "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-semibold">Date</span> : {formatDateWithTime(invoiceData?.date_creation)}
          </p>
        </div>
      </div>

      <p className="text-right mt-2 font-medium text-xl">
        <span className="font-bold uppercase">
          {invoiceData.paye_complet
            ? invoiceData.statut_commande === "annulé"
              ? "Facture d'avoir"
              : "Facture de vente"
            : "Décharge N°"}
        </span>
        {invoiceData.designation && ` : ${invoiceData.designation}`}
      </p>


      {(() => {
        try {
          const parsed = invoiceData?.emecef_data && JSON.parse(invoiceData.emecef_data);
          return parsed?.codeMECeFDGI && !parsed?.errors && invoiceData.statut_commande === "annulé" ? (
            <p className="text-right font-medium text-sm">
              <span className="font-bold">Référence de la facture originale</span><br />
              {parsed.codeMECeFDGI}
            </p>
          ) : null;
        } catch (e) {
          console.error("Erreur lors du parsing :", e);
          return null;
        }
      })()}

      <div className="overflow-x-auto">
        <table className="border-collapse mt-3 w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr className="">
              <th className="p-2 border font-semibold pe-7">Code client</th>
              <th className="p-2 border font-semibold text-start">Client</th>
              <th className="p-2 border font-semibold">IFU</th>
              <th className="p-2 border font-semibold">Téléphone</th>
            </tr>
          </thead>
          <tbody className="">
            <tr>
              <td className="p-2 border font-medium">{invoiceData?.customer?.client_code || "-"}</td>
              <td className="p-2 border font-medium">{invoiceData?.customer?.name || "-"}</td>
              <td className="p-2 border font-medium">{invoiceData?.customer?.ifu || "-"}</td>
              <td className="p-2 border font-medium">{invoiceData?.customer?.numero || "-"}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="overflow-x-auto">
        <table className="border-collapse w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr className="">
              <th className="p-2 border font-semibold text-sm">
                Magasin
              </th>
              <th className="p-2 border font-semibold text-sm">
                Produit
              </th>
              <th className="p-2 border font-semibold text-sm">
                Prix Unitaire
              </th>
              <th className="p-2 border font-semibold text-sm pe-7">
                Quantité
              </th>
              <th className="p-2 border font-semibold text-sm">
                Prix Total
              </th>
            </tr>
          </thead>
          <tbody className="">
            {lineItems.length > 0 ? (
              lineItems.map((item, index) => {
                const unitPrice = Number(item.p2 ?? item.prix_unitaire ?? 0);
                const qty = Number(item.quantite ?? 0);
                const taxGroup = lineTaxGroupLabel(item);
                const lineTotal = unitPrice * qty;

                return (
                <tr key={index}>
                  <td className="p-2 border font-medium text-sm">
                    {getOrderLineWarehouseCode(item)}
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {item.name} ({taxGroup})
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {formatNumber(unitPrice)} FCFA
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {qty} {item.unite === 'Mettre carré' ? 'm²' : item.unite === 'Pièce' ? 'pc' : item.unite}
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {formatNumber(lineTotal)} FCFA
                  </td>
                  {/* <td className="p-2 border font-medium text-sm">
                    {item.variant.is_taxable
                      {formatNumber(item.p2 * item.quantite)} FCFA
                      : '—'}
                  </td> */}
                </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" className="p-2 font-medium text-center text-sm">
                  Aucun produit dans le panier.
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={3} className="p-2 border font-semibold text-sm">
                Commentaires
              </td>
              <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                <b>{isRevendeur ? 'Sous-total lignes' : 'Total'} :</b>{' '}
                {formatNumber(isRevendeur ? revendeurLineTotal : invoiceData.montant_net)} FCFA
              </td>
            </tr>
            <tr>
              <td
                colSpan={3}
                rowSpan={isRevendeur ? 2 : 4}
                className="border-e-0 p-2 border font-medium text-sm"
              >
                Les marchandises vendues ne sont ni reprises ni échangées. <br />La disponibilité de votre achat n'est plus garantie 14 jours <br />après la date de facturation.
              </td>
              {!isRevendeur && (
                <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                  <b>Montant HT :</b> {formatNumber(invoiceData.montant_ht)} FCFA
                </td>
              )}
            </tr>
            {!isRevendeur && invoiceData.tva > 0 && (
              <tr>
                <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                  <b>T.V.A (18%) :</b> {formatNumber(invoiceData.tva)} FCFA
                </td>
              </tr>
            )}
            {!isRevendeur && invoiceData.aib_value && (
              <tr>
                <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                  <b>AIB (0{invoiceData.aib_value === 'A' ? '1' : invoiceData.aib_value === 'B' ? '5' : ''}%) :</b> {formatNumber(invoiceData.aib)} FCFA
                </td>
              </tr>
            )}
            {!isRevendeur && invoiceData.remise > 0 && (
              <tr>
                <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                  <b>Remise :</b> {formatNumber(invoiceData.remise)} FCFA
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                <b>{isRevendeur ? 'Montant payé' : 'NET'} :</b> {formatNumber(netAmount)} FCFA
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {!invoiceData.paye_complet && (
        <div className="overflow-x-auto">
          <table className="border-collapse w-full text-sm whitespace-pre table-auto">
            <thead>
              <tr className="">
                <th className="p-2 border font-semibold text-start">Net à payer</th>
                <th className="p-2 border font-semibold text-start">Montant payé en avance</th>
                <th className="p-2 border font-semibold">Total dû</th>
              </tr>
            </thead>
            <tbody className="">
              <tr>
                <td className="p-2 border font-medium">{formatNumber(netAmount)} FCFA</td>
                <td className="p-2 border font-medium">{formatNumber(invoiceData.avance_payee)} FCFA</td>
                <td className="p-2 border font-medium">{formatNumber(invoiceData.total_du)} FCFA</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      <div className="flex flex-wrap justify-between items-center gap-6 mt-3">
        <div>
          {invoiceData.paye_complet ? (
            <p className="font-medium text-sm capitalize">
              <span className="font-bold">Montant en lettre</span> : {convertNumberToWordsInFCFA(Math.round(netAmount))}
            </p>
          ) : (
            <>
              <p className="font-medium text-sm capitalize">
                <span className="font-bold">Net à payer en lettre</span> : {convertNumberToWordsInFCFA(netAmount)}
              </p>
              <p className="font-medium text-sm capitalize">
                <span className="font-bold">Montant payé en avance</span> : {convertNumberToWordsInFCFA(invoiceData?.avance_payee)}
              </p>
            </>
          )}
          <p className="font-medium text-sm">
            <span className="font-bold">Mode de règlement</span> : {invoiceData?.mode_reglement?.nom || "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-bold">Référence de la pièce</span> : {invoiceData?.reference_piece || "Non spécifiée"}
          </p>
        </div>
      </div>
    </div>
  );
}